import { PrivacyScreenConfig } from "@capacitor/privacy-screen";

export const PRIVACY_SCREEN_CONFIG: PrivacyScreenConfig = {
  android: {
    preventScreenshots: false,
    dimBackground: true,
    privacyModeOnActivityHidden: "splash",
  },
};

// Shared biometric-related types and enums to avoid circular dependencies
export enum BiometricEnrollmentError {
  BIOMETRY_NOT_AVAILABLE = "BIOMETRY_NOT_AVAILABLE", // BIOMETRICS
  USER_LOCKOUT = "USER_LOCKOUT", // BIOMETRICS
  USER_TEMPORARY_LOCKOUT = "USER_TEMPORARY_LOCKOUT", // BIOMETRICS
  BIOMETRIC_VERIFICATION_FAILED = "BIOMETRIC_VERIFICATION_FAILED", // BIOMETRICS — real auth failure (wrong biometric)
  SYSTEM_CANCELLED = "SYSTEM_CANCELLED", // BIOMETRICS — OS/app cancelled the prompt (not the user)
  PASSCODE_NOT_SET = "PASSCODE_NOT_SET", // BIOMETRICS — device has no passcode configured
  USER_CANCELLED = "USER_CANCELLED", // BIOMETRICS
  UNKNOWN_ERROR = "UNKNOWN_ERROR", // BIOMETRICS
}

// Biometric refresh token expiry (used for opt-in save and fallback on refresh)
export const BIOMETRIC_REFRESH_TTL_SECONDS = 30 * 24 * 60 * 60;

// Flag to indicate if biometric credential has been saved
export const BIOMETRIC_CREDENTIAL_SAVED_KEY = "biometricCredentialSaved";
